//TODO: rid underscore dependency -- will also optimize

(function(R) {

    // Return an array of {x:y} coordinates for all points in a path.
    // isWithTransform: provide as true if you want to include the position of the transformed coordinates.
    // Note: since historically I wasn't taking transforms into account, the parameter
    // is named 'isWithTransform' -- unlike Raphael's 'isWithoutTransform' for bbox -- so false is the default.
    R.el.getPathCoordinates = function( isWithTransform ) {

        // If read in from file could be a convert string to array.
        // If already an array, Raphael method checks and doesn't do much processing.
        // If performance becomes an issue -- can look to optimize.

        var path = Raphael.parsePathString( this.attr('path') );

        // Handle case where path is yet to be defined -- parsePathString returns null here.
        if ( !path )
            return [];

        return R.fn.getPathCoordinates( path, isWithTransform ? this.transform() : undefined );

    };

    // If transform is provided, adjust the path with the transform string.
    // If performance becomes an issue, when a transform is provided, can optimize by adjusting the points directly here.
    R.fn.getPathCoordinates = function(path, transform) {

        path = !transform
            ? path
            : R.fn.mapPathStraight( path, R.toMatrix( path, transform ) );  // transformPath will turn into C's and not work

        var coordinates = [];

        for ( var i=0; i<path.length; i++ ) {

            var segment = path[i];
            if ( segment[0] === 'Z' )
                continue;

            coordinates.push({ x: segment[1], y: segment[2] });
        }

        return coordinates;

    };


    R.el.setPathFromPtsArray = function( ptsArray, closePath ) {

        var path = R.fn.getPathFromPtsArray( ptsArray, closePath );
        this.attr('path', path);
        return this;

    };

    R.fn.getPathFromPtsArray = function( ptsArray, closePath ) {

        var ptsArray = _.reject( ptsArray, function(p) {
                return p === 'Z';
            }),
            path = 'M' + ptsArray[0].x + ' ' + ptsArray[0].y;

        // could use map/reduce here
        _.each( _.rest(ptsArray), function(p) {
            path += 'L' + (p.x) + ' ' + (p.y);
        });

        if (closePath)
            path += 'Z';

        return path;
    };

    R.fn.rectPath = function(x, y, w, h) { //w and height must be > 0
        var path = 'M' + x + ' ' + y;
        path += 'L' + (x + w) + ' ' + y;
        path += 'L' + (x + w) + ' ' + (y + h);
        path += 'L' + x + ' ' + (y + h);
        path += 'Z';
        return path;
    };

    /* Outer offset from the box -- default is Zero */
    R.el.getPathOfBBox = function(includeTransform, offset) {

        var O = offset !== undefined
            ? offset
            : 0;

        var box = this.getBBox(includeTransform !== undefined),
            p = 'M' + (box.x - O) + ' ' + (box.y - O);

        p += 'L' + (box.x2 + O) + ' ' + (box.y - O);
        p += 'L' + (box.x2 + O) + ' ' + (box.y2 + O);
        p += 'L' + (box.x - O) + ' ' + (box.y2 + O);
        p += 'Z';

        return p;

    };



    /* Determine if array of shape pts is rectangular */
    R.fn.isRect = function(pts) {
        if (pts.length !== 4) { return false; }
        var tl = {x: pts[0][1], y: pts[0][2]},
            tr = {x: pts[1][1], y: pts[1][2]},
            br = {x: pts[2][1], y: pts[2][2]},
            bl = {x: pts[3][1], y: pts[3][2]},
            tla = R.angle(bl.x, bl.y, tr.x, tr.y, tl.x, tl.y) % 90, /* using mod 90 b/c bla gives 270  -- want all to be right angles */
            tra = R.angle(tl.x, tl.y, br.x, br.y, tr.x, tr.y) % 90,
            bra = R.angle(tr.x, tr.y, bl.x, bl.y, br.x, br.y) % 90,
            bla = R.angle(tl.x, tl.y, br.x, br.y, bl.x, bl.y) % 90;
        return (tla === 0 && tra === 0 && bra === 0 && bla === 0);
    };

    /* determine whether a path of points is a rectangle*/
    R.el.pathIsRect = function () {
        var pts = _.reject(R.parsePathString(this.attr('path')), function (p) {
            return p[0] === 'Z';
        });  //(get rid  z
        return R.fn.isRect(pts);
    };

//* NOTE FOR NOW USE CHECKING 2 POINTS -- CAN LATER PUT IN ANGLE CHECK */
    R.el.pathIsLine = function () {
        var path = R.parsePathString(this.attr('path'));
        return R.fn.pathIsLine( path ) ;
    };

    R.fn.pathIsLine = function(path) {
        return path.length === 2;
    };

    /* Replace path with transformations by computing new actual values in the path from the transform */
    R.el.bakeTransform = function(keepStrokeWidth) {

        var fnKeepStrokeWidth = function() {
            //        // console.log(swRatio); //todo: make more accurate method
            ////        if Rapahel.svg( ) --> 'preserve stroke width' vector-effect="non-scaling-stroke
            //        //parseFloat($(this.node).attr('stroke-width')) -- can get the scaled prior to transform ... as attr
            //        //this would be the original, not accounting for scale  -- this is better: could calc the diff in change in x and y (translate for more accuracy)
            //        //eg: sx / tx and sy / ty
            //        //if vml use the average of the x and y scale
            var osw = this.attr('stroke-width');
            var m = this.matrix.split();
            var scaleAvg = (m.scalex + m.scaley) / 2;
            this.attr('stroke-width', osw * scaleAvg);

        },
            oPath = R.parsePathString( this.attr('path') );//need to normalize first for IE8 --- ISSUE VML IS RELATIVE, SVG IS NOT -- todo: only if IE for PERF

        //if (R.vml) oPath = R._pathToAbsolute(oPath);  //need for IE8: path to string here is relative: //TODO: STILL NEEDED?

        oPath = R._pathToAbsolute(oPath);

        var pathHasCurves = oPath.toString().indexOf('C') > -1;  //this would be text

        if ( pathHasCurves ) { //if the path has curves -- don't use the hack

            this.attr('path', R.mapPath( oPath, this.matrix) );

        } else
        {

            //version with hack) // TODO: STILL NECESSARY ?
            var trans = R.parseTransformString(this.transform()),
                trpath = R.prototype.mapPathStraight(oPath, R.toMatrix(oPath, trans));

            this.attr('path', trpath);
        }

        if (keepStrokeWidth)
            fnKeepStrokeWidth.call(this);

        this.transform('');
        return this;
    };

    R.st.bakeTransform = function (keepStrokeWidth) {
        this.forEach(function (el) {
            el.bakeTransform(keepStrokeWidth);
        });
        return this;
    };

    //TODO: optimize, round
    R.el.scalePathWithCurves = function(scale, lastScale) {

        var C = scale / lastScale,
            p = this.attr('path'),
            isClosed = _.last(p).toString().toUpperCase() === 'Z',
            newPath = _.chain( R.parsePathString(p) )
                .map(function (aSegment) {

                    return _.map(aSegment,function (p) {
                        return isNaN(p) ? p : (p *= C) + ',';
                    }).join('').slice(0, -1);

                }).value().join(' ');

        if (isClosed)
            newPath += 'Z';

        this.attr('path', newPath);

        return this;

    };

    /**
     * Note: only applies to paths.
     * @returns {R.st}
     */
    R.st.scaleWithPaper = function() {

        this.forEach (function(el) {
            el.scalePathWithCurves.apply(el, arguments);
        });

        return this;

    };


    /**
     * Return path modified by given fn.
     * Note: could now use for scale -- eg:
     *  R.fn.adjustPath(oPath, function(i) {return i*= 0.5;} ); -- ( for now used for SVG )
     */
    R.fn.adjustPath = function(path, fn) {
        return _.chain(R.parsePathString(path))
            .map(function (aSegment) {
                return _.map(aSegment,function (p) {
                    return isNaN(p) ? p : (fn(p)) + ',';  //NOTE: ONLY USABLE IF SAME ADJ APPLIED TO ALL POINTS -- WOULDN'T DO ROTATE OF 'C'
                }).join('');
            }).value().join(' ');
    };

    /* Create Path From Rectangle Element -- todo: used still? */
    R.el.pathFromRect = function () {
        if (this.type !== 'rect') {
            return false;
        }
        var oAttrs = this.attrs,
            x = oAttrs.x,
            y = oAttrs.y,
            w = oAttrs.width,
            h = oAttrs.height,
            paper = this.paper,
            el,
            path = 'M' + x + ' ' + y;
        path += 'L' + (x + w) + ' ' + y;
        path += 'L' + (x + w) + ' ' + (y + h);
        path += 'L' + x + ' ' + (y + h);
        path += 'Z';
        /* Must exclude path attr for IE8 (for R.vml) -- otherwise the new path value will remain the old */
        el = paper.path(path).attr(_.omit(oAttrs, ['height', 'r', 'rx', 'ry', 'width', 'x', 'y', 'path'])).insertAfter(this);
        this.remove();
        return el;
    };

    // TODO: i dont see this used any longer
    R.el.rectFromPath = function () {
        var oAttrs = this.attrs,
            pts = this.getPathCoordinates(),
            x = pts[0].x,
            y = pts[0].y,
            w = pts[1].x - x,
            h = pts[2].y - y,
            paper = this.paper,
            el = paper.rect(x, y, w, h).attr(_.omit(oAttrs, 'path')).insertAfter(this);
        this.remove();  //do after insert (give it the 'zindex'/layer)
        return el;
    };


    /**
     * R patch -- see issue below.
     * http://stackoverflow.com/questions/14689947/R-transformpath-to-return-lines-instead-of-curves
     */
    R.fn.mapPathStraight = function (path, matrix) {
        if (!matrix) {
            return path;
        }
        var x, y, i, j, ii, jj, pathi;

        //replace following line with .parsePathString(), which also parses path string into an array without adding curves
        //path = path2curve(path);
        path = R.parsePathString(path);
        for (i = 0, ii = path.length; i < ii; i++) {
            pathi = path[i];
            for (j = 1, jj = pathi.length; j < jj; j += 2) {
                x = matrix.x(pathi[j], pathi[j + 1]);
                y = matrix.y(pathi[j], pathi[j + 1]);
                pathi[j] = x;
                pathi[j + 1] = y;
            }
        }
        return path;
    };


    /**
     * Monkey Patch: Glow: Use Actual Path: not internal 'realPath'.
     * Allow Glow for Text Elements.
     */
    R.el.glow = function(glow) {

        //if (this.type == "text") {
        //    return null;
        //}
        glow = glow || {};

        var s = {
                width: (glow.width || 10) + (+this.attr("stroke-width") || 1),
                fill: glow.fill || false,
                opacity: glow.opacity || .5,
                offsetx: glow.offsetx || 0,
                offsety: glow.offsety || 0,
                color: glow.color || "#000"
            },
            c = s.width / 2,
            r = this.paper,
            out = r.set(),
        // path = this.realPath || getPath[this.type](this);
            path = R._getPath[this.type](this);

        path = this.matrix
            ? R.mapPath(path, this.matrix)
            : path;

        for (var i = 1; i < c + 1; i++) {
            out.push(r.path(path).attr({
                stroke: s.color,
                fill: s.fill ? s.color : "none",
                "stroke-linejoin": "round",
                "stroke-linecap": "round",
                "stroke-width": +(s.width / c * i).toFixed(3),
                opacity: +(s.opacity / c).toFixed(3)
            }));
        }

        return out.insertBefore(this).translate(s.offsetx, s.offsety);

    };

    /* TODO: name appropriately */
    R.el.setBoxTransformStr = function() {
        var t = this.getBoxTransformStr.apply(this, arguments);
        this.transform(t);
        return this;
    };

    /* X, Y are offset mouse position, cursor -- '**re-size' (for now, represents the cursor attr) */
    /* Done Via Scale Transform To Resize 'Free Box */
    R.el.getBoxTransformStr = function(x, y, includeTransform, isEast, isSouth, preserveAspectRatio, applyTrans) {

        var box = this['cachedBox'] || this.getBBox(includeTransform !== undefined),
            dx, dy, cx, cy, sx, sy;  //dx, dy is the hor or vert change; cx/cy is the scale origin

        var t = applyTrans !== undefined
            ? this.transform() + ' '
            : '';

        if (!isEast) {
            cx = box.x2;
            dx = (x - cx) * -1;
        } else {
            cx = box.x;
            dx = (x - cx);
        }
        if (!isSouth) {
            cy = box.y2;
            dy = (y - cy) * -1;
        } else {
            cy = box.y;
            dy = (y - cy);
        }

        sx = dx / box.width;
        sy = dy / box.height;


        if (preserveAspectRatio) {
            // quick hack to preserve aspect ratio
            // issue with keeping mouse at the same position on resize but ok for now
            // can later revist
            if (sx > sy ) {
                sy = sx;
            } else if (sy > sx) {
                sx = sy;
            }
        }

        t += 'S' + sx + ', ' + sy + ', ' + cx + ', ' + cy; //S MUST BE ABS (... still?)

        this['cachedBox'] = box;

        //note: be sure to delete the 'CACHED BOX' on resize/draw end or start for subsequent calls (can be relative ...);
        return t;
    };

    /* for when used in tandem with getBoxTransformStr -- TODO: sloppy */
    R.el.removeCachedBox = function() {
        if (this.cachedBox) delete this.cachedBox;
        return this;
    };


    R.el.nonScalingStroke = function () {
        if (R.svg) {
            $(this.node).css('vector-effect', 'non-scaling-stroke');
        }
    };

    R.fn.rotatePt = function(pt, deg, cx, cy) {
        var m = new R.matrix;
        m.rotate(deg, cx, cy);
        return {
            x: m.x(pt.x, pt.y),
            y: m.y(pt.x, pt.y)
        };
    };

    //ben: unbindall doesn't exist in R library -- created own -- to do: get the events of the view, also on th el
    R.el.unbindAll = function () {
        while (this.events.length) {
            var e = this.events.pop();
            e.unbind();
        }
    };

    R.st.unbindAll = function () { //todo: works but does calls of events of all children too (eg the click)
        this.el.forEach(function (el) {
            el.unbindAll();
        });
    };

    R.fn.fadeIn = function(ms, easing) {
        this.animate({opacity: 1.0}, ms ? ms : 200, easing ? easing : '>' );
    };

    R.fn.fadeOut = function(ms, easing) {
        this.animate({opacity: 0.0}, ms ? ms : 200, easing ? easing : '>' );
    };

    R.st.fadeIn = function() {
        var args = Array.prototype.slice.call(arguments);
        this.forEach(function(el) {
            R[el.length > 1 ? 'st' : 'fn'].fadeIn.prototype.constructor.apply(el, args);
        });
        return this;
    };

    R.st.fadeOut = function() {
        var args = Array.prototype.slice.call(arguments);
        this.forEach(function(el) {
            R[el.length > 1 ? 'st' : 'fn'].fadeOut.prototype.constructor.apply(el, args);
        });
        return this;
    };

    /* Return a new element clone from this one, with it's attributes, overwritten with any given */
    R.el.replaceWithClone = function(attrs) {
        var old = this,
            newShape = this.clone(); //attributes copied, TODO: optional data
        newShape.attr(_.extend(old.attrs, attrs));
        newShape.insertBefore(old);
        old.remove();
        return newShape;
    };

    //abstract about the scaling to fit the size of the old
    /* essentially 'stretch-fit' */
    /* if don't provide otherEl assume, replacing itself*/
    /* rotation is optional, provide if want to position over the other shape rotated to that degree */
    /* better name:  var textPathScaledToFitBox = Raphael.fn.fitTextAtopOtherText();? ... */

    /* otherEl can be a bounding box*/

    R.el.fitAndPositionPathToMatchAnother = function(otherEl, rotation) { /* eg for text paths -- change of font, fit a position */

        var otherBox;
        if (!otherEl) {
            otherBox = R.pathBBox(this.attr('path')); /* fit itself by default */
        } else {

            var otherElIsBox = !otherEl.attrs; /* could be R.pathBBox */
            otherBox = otherElIsBox
                ? otherEl  /* assumes it is already a box */
                : R.pathBBox(otherEl.attr('path'));
        }


        //todo: rotation working but want in other matrix calc for perf
        rotation && this.rotate(rotation).bakeTransform();

        var box = this.getBBox(),
            dx = otherBox.x - box.x,
            dy = otherBox.y - box.y,
            sx = otherBox.width / box.width,
            sy = otherBox.height / box.height,
            cx = box.x,
            cy = box.y,
            mx = R.matrix();

        mx.translate(dx, dy);
        mx.scale(sx, sy, cx, cy); /* cx, cy necessary to work with elements not positioned at 0, 0 */

        /* use this instead of mapPath b/c looks like bug in mapPath (which still isn't working when using the relative, not absolute path */
        var relTrans = mx.toTransformString();
        var pathWithMx = R.transformPath(this.attr('path'), relTrans); /* must use relative transform to work on shapes not at 0,0 */

        this.attr('path', pathWithMx);

        return this;
    };

    R.el.getPaperCenter = function() {
        var canvas = this.paper.canvas;
        return {
            x: canvas.clientWidth / 2,
            y: canvas.clientHeight / 2
        };
    };

    /* Return adjusted path from a given path, page scale, and page rotation */
    /* note: originalCenterPtRotated is also scaled */
    //TODO: now passing in originalCenterPtRotated --- but i think can now do with mx -- see fitAndPositionPathToMatchAnother
    R.fn.viewerAdjustedPath = function(originalPath, scale, rotation, originalCenterPtWithScaleAndRotationApplied) {

        rotation = rotation % 360; //(mod fixes over 360), -- not really necessary (done on server) ? still -- do in page model?

        var scaledPath = R.fn.adjustPath(originalPath, function(n) {
            return n * scale;
        });

        //TODO: can now inc perf by combo'ing the calc utilizing a matrix (map path)

        if (rotation === 0) return scaledPath;

        /* adjust path for rotation, (already scaled) */
        var c = originalCenterPtWithScaleAndRotationApplied, /* include scale in adjustment */
            rc = R.fn.rotatePt({x: c.x, y: c.y}, rotation, 0, 0),
            dc = {  //use to translate after other rotation
                x: c.x  - Math.abs(rc.x) ,
                y: c.y - Math.abs(rc.y)
            },
            t = 'R' + rotation + ',' + c.x + ',' + c.y +  ' t' + dc.x + ',' + dc.y;

        return R.transformPath(scaledPath, t);
    };

    // The opposite of viewerAdjust -- normalize back to scale of 1 and if rotated, rotate back.
    // Perform rounding of coordinates -- this is what is called for persistence.
    // Note: any potential transforms on the path element not taken into account
    R.fn.viewerUnadjustedPath = function(originalPath, scale, rotation, origDimsWithScaleApplied, originalCenterPtWithScaleAndRotationApplied) {

        rotation = rotation % 360; //TODO: in caller

        // ( scaledPath also performs rounding )
        var scaledPath = function(path) {
            return R.fn.adjustPath(path, function(n) {
                return +(n / scale).toFixed(3);
            });
        };

        if (rotation === 0)
            return scaledPath(originalPath);

        // rotation
        var rotTo0 =  -1 * rotation,
            dims = origDimsWithScaleApplied,
            c = {
                x: Math.round( dims.w / 2 ),  //TODO: pass c instead -- need to know .w vs .width ...
                y: Math.round( dims.h / 2 )
            },
            rc = originalCenterPtWithScaleAndRotationApplied, //only abs values used in calc -- (not scaled)
            dc = {
                x: c.x  - Math.abs(rc.x) ,
                y: c.y - Math.abs(rc.y)
            },
            t = 'R' + rotTo0 + ',' + c.x + ',' + c.y +  ' t' + dc.x + ',' + dc.y;

        var rotatedPath = R.transformPath(originalPath, t);
        var scaledRotatedPath = scaledPath(rotatedPath);

        return scaledRotatedPath;

    };

    R.el.isPath = function() {
        return this.node.tagName.toLowerCase() === 'path';
    };

    // return array of pts from a Raphael Bounding box
    R.fn.getCoordinatesFromBBox = function(box) {
        return [
            {x: box.x,	y: box.y},
            {x: box.x2,	y: box.y},
            {x: box.x2, y: box.y2},
            {x: box.x,	y: box.y2}
        ];
    };

    // If element has either a stroke or fill, change them to the provided color
    R.el.setStrokeAndFill = function(color) {
        var attrs = this.attr();
        attrs.fill && attrs.fill !== 'none' && ( this.attr('fill', color ) );
        attrs.stroke && attrs.stroke !== 'none' && ( this.attr('stroke', color) );
        return this;
    };

    // https://stackoverflow.com/questions/12059592/triggering-raphael-events-externally
    // forked to add the e to the original event for 'drag'
    R.el.trigger = function(eventName, e){
        for(var i = 0, len = this.events.length; i < len; i++) {
            if (this.events[i].name == eventName) {
                this.events[i].f.call(this, e);
            }
        }
    };


    /** --- Text path functions created for text stamps  ---- */

    /**
     * Replace the text of a path created with paper.print
     * keepTopLeftPosition: use if you want to keep in place at the top, left of the existing position.
     * ( if transformed, you may not care )
     * Use when desirable to not delete and create a new element.
     * Raphael paper.print works at the element level -- there isn't a fn
     * to generate the path so this is a 'heavy' solution:
     * create a hidden element, get it's path, set it, remove the hidden element.
     * font & fontSize: required ( these aren't attributes b/c we are talking about a path )
     * ... I suppose could set as data-attrs ...
     */

    R.el.replaceTextPath = function( text, font, fontSize, keepTopLeftPosition ) {

        var paper = this.paper;

        if ( typeof font === 'string' ) {
            font = paper.getFont( font );
        }

        var temp = paper.print( 0, 0, text, font, parseFloat( fontSize ), 'baseline' )
            .hide();

        var newPath =  temp.attr('path');

        if ( keepTopLeftPosition ) {

            var obox = this.getBBox();
            newPath = R.fn.getTextPathAtTopLeftPosition( newPath, obox.x, obox.y );

        }

        this.attr( 'path', newPath );

        temp.remove();

        return this;

    };


    /**
     * Originally placed position can be different than the bbox )
     */
    R.el.moveTextPathToTopLeft = function( x, y, x_padding, y_padding ) {

        this.attr( 'path', R.fn.getTextPathAtTopLeftPosition( this.getPath(), x, y, x_padding, y_padding ) );
        return this;

    };

    /* May be more efficient way by hooking into the font metrics */
    R.fn.getTextPathAtTopLeftPosition = function( path, x, y, x_padding, y_padding ) {

        x_padding = x_padding || 0;
        y_padding = y_padding || 0;

        var box = R.pathBBox( path );
        var dx = x - box.x + x_padding;
        var dy = y - box.y + y_padding;

        return R.transformPath( path, 't' + dx + ',' + dy );
    };


    /**
     * Wrapper around paper.print to position text at provided top, left coordinates.
     * options: keys are the same as the parameters for paper.print as well as
     * arguments for this function.
     */
    R.fn.printAtTopLeftPosition = function( options ) {

        return this.print( options.x, options.y, options.text, options.font, options.size, 'baseline', options.letter_spacing  )
            .moveTextPathToTopLeft( options.x, options.y, options.x_padding, options.y_padding );

    };


    /* -- End Text Stamp New Text Path Functions -- */


})(Raphael);




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/extension/raphael/raphael.js
 ** module id = 198
 ** module chunks = 0
 **/